'use strict';

export default function() {
  $(document).delegate('#updateRetailerBtn', 'click', function() {
    var url = $('#prefferedRetailerId').val();
    if (url.indexOf('=') != -1) {
      var start = url.indexOf('=');
      var length = url.length;
      var store = url.substring(start + 1, length);
      ACC.track.trackPreferredRetailer(store);
    }
    $.ajax({
      url: url,
      type: 'POST',
      success: function() {
        $('#updateRetailerDiv').css('display', 'none');
      },
    });
  });
}

function disableOrderSubmitButton() {
  $('#orderSubmitButton').addClass('disabled');
  $('#orderSubmitButton').prop('disabled', true);
}

function enableOrderSubmitButton() {
  $('#orderSubmitButton').removeClass('disabled');
  $('#orderSubmitButton').removeProp('disabled');
  $('#orderSubmitButton').removeAttr('disabled');
}

function populateStepUpIframe(url, jwt) {
  const stepUpHtml = `<form id="stepupForm" name="stepupForm" method="POST" action="${url}">
     <input type="hidden" name="JWT" value="${jwt}">
      <script type="text/javascript">
        window.onload = function(){ document.getElementById('stepupForm').submit(); }
     </script>`;

  $('#payer-auth-iframe').attr('src', 'data:text/html;charset=utf-8,' + encodeURI(stepUpHtml));
}

$(document).delegate('#placeOrderForm1', 'submit', function() {
  disableOrderSubmitButton();
});

function getDeviceCollectionIframeContents(jwt, url) {
  return `
         <!DOCTYPE html>
         <html>
           <head>
           </head>
           <body>
             <form id="collectionForm" name="devicedata" method="POST" action="${url}">
               <input type="hidden" name="JWT" value="${jwt}" />
             </form>
             <script>
               document.getElementById('collectionForm').submit();
             </script>
           </body>
         </html>
       `;
}

function populateResponseFields(responseData) {
  /* populates the hidden field in cybersourceCheckoutSummaryPage
   for the BE to use when the form submits to the validate endpoint */
  $('#enrollmentCheckTransactionStatus').val(responseData.transactionStatus);
  $('#enrollmentResponseReasonCode').val(responseData.reasonCode);
  $('#enrollmentResponseTransactionId').val(responseData.authenticationTransactionId);
}

function transactionStatusCheck(responseData) {
  const transactionStatus = responseData.transactionStatus ? responseData.transactionStatus : '';

  if (transactionStatus === 'PENDING') {
    // card is enrolled and step up is required
    $('#payer-auth-modal').foundation('open');
    $('#payer-auth-modal').one('closed.zf.reveal', enableOrderSubmitButton);
    populateStepUpIframe(responseData.stepUpUrl, responseData.accessToken);
  } else {
    /* This handles the proceed to authorization (reason code = 100) case
		and error cases where the BE will redirect based on hidden fields */
    $('#placeOrderForm1').submit();
  }
}

function payerAuthCompleteCheck(event) {
  // check for payerAuthComplete event data message
  return (
    event.data &&
    event.data.messageType &&
    event.data.messageType === 'payerAuthComplete' &&
    event.origin === window.location.protocol + '//' + window.location.host
  );
}

/* This listens for the postMessage from the payerAuthComplete page which lets us
  know when to close the payerAuthIframe and submit the form to the validate endpoint */
window.addEventListener(
  'message',
  function(event) {
    if (payerAuthCompleteCheck(event)) {
      // close the modal & Iframe
      $('#payer-auth-modal').foundation('close');
      // submit the form to the validate endpoint
      $('#placeOrderForm1').submit();
    }
  },
  false
);

function confirmationCompleteCheck(event) {
  // check for payerAuthComplete event data message
  return (
    event.data &&
    event.data.messageType &&
    event.data.messageType === 'confirmationValidationEvent' &&
    event.origin === window.location.protocol + '//' + window.location.host
  );
}

/* This listens for the postMessage from the confirmationValidationEvent page which lets us
  know when to close the payerAuthIframe and submit the form to the validate endpoint */
window.addEventListener(
  'message',
  function(event) {
    if (confirmationCompleteCheck(event)) {
      // handle payment rejection payer auth failure and redirect the user
      if (event.data.errorRedirectUrl) {
        $('#payer-auth-modal').foundation('close');
        window.location.replace(window.ACC.config.encodedContextPath + event.data.errorRedirectUrl);
      }
      // submit the form to the validate endpoint
      if (event.data.type !== 'false') {
        $('#payer-auth-modal').foundation('close');

        $.ajax({
          url: '/checkout/multi/summary/v2/',
          type: 'POST',
          data: $('#placeOrderForm1').serialize(),
          success: function(response) {
            if (response.data.htmlOfAutosubmitForm) {
              const wrapperSubmitForm = document.createElement('div');
              wrapperSubmitForm.innerHTML = response.data.htmlOfAutosubmitForm;
              const submitForm = wrapperSubmitForm.firstChild;
              document.body.append(submitForm);
              submitForm.submit();
            }
          },
          error: function(error) {
            $('#payer-auth-modal').foundation('close');
            enableOrderSubmitButton();
            console.log(error);
          },
        });
      } else {
        // close the modal & Iframe
        $('#payer-auth-modal').foundation('close');
        enableOrderSubmitButton();
      }
    }
  },
  false
);

$(document).ready(function() {
  // Create payer auth device collection iframe
  const jwtHolder = $('#payerAuthDeviceAccessToken');
  const deviceCollectionUrl = $('#payerAuthDeviceCollectionURL');
  if (jwtHolder && jwtHolder.val()) {
    const deviceCollectionIframe = document.createElement('iframe');
    deviceCollectionIframe.width = 1;
    deviceCollectionIframe.height = 1;
    deviceCollectionIframe.style = 'display: none';
    document.body.append(deviceCollectionIframe);
    deviceCollectionIframe.contentDocument.write(
      getDeviceCollectionIframeContents(jwtHolder.val(), deviceCollectionUrl.val())
    );
  }

  function CheckoutCompleteOrderV2() {
    /**
     * Initialize form and process with next step.
     * @param htmlCode
     */
    this.init = function(htmlCode) {
      const form = this.setupForm(htmlCode);
      if (!form) {
        throw new Error("Form doesn't exist");
      }

      if (form.classList.contains('iframe')) {
        this.initIframePopup(htmlCode);
      } else {
        form.submit();
      }
    };

    /**
     * Initialize iframe and popup.
     */
    this.initIframePopup = function(htmlCode) {
      const $modal = $('#payer-auth-modal');
      const $iframe = $('#payer-auth-iframe');

      $modal.foundation('open');
      $modal.one('closed.zf.reveal', enableOrderSubmitButton);

      $iframe
        .contents()
        .find('body')
        .html(htmlCode);

      $iframe
        .contents()
        .find('#step-up-form')
        .attr('target', '')
        .submit();
    };

    /**
     * Add form to DOM tree.
     * @param htmlCode
     * @return {ChildNode}
     */
    this.setupForm = function(htmlCode) {
      const wrapperSubmitForm = document.createElement('div');
      wrapperSubmitForm.innerHTML = htmlCode;

      const submitForm = wrapperSubmitForm.firstChild;
      document.body.append(submitForm);
      return submitForm;
    };
  }

  // When we are using 3D Secure for added payer authentication
  $('#orderSubmitButtonV2,#orderSubmitButton[data-cybersource-payer-auth-enabled]').click(function(evt) {
    evt.preventDefault();

    // If Terms & Conditions is not checked, submit to backend normally and it will reload the page showing an error.
    // Otherwise, we're going to check with backend to see if we need to pop open a modal window to load the bank's iframe
    const isV2 = $(evt.delegateTarget).attr('id') === 'orderSubmitButtonV2';
    let successResponse;
    let endpointUrl = '';

    if (isV2) {
      endpointUrl = window.ACC.config.encodedContextPath + '/checkout/multi/summary/v2/';
      successResponse = function(response) {
        // handle enrollment check failure and redirect the user
        if (response.data.errorOccurred) {
          window.location.replace(
            window.ACC.config.encodedContextPath + response.data.htmlOfAutosubmitForm + response.data.errorMessages[0]
          );
        }

        if (response.data.htmlOfAutosubmitForm) {
          const checkoutCompleteOrderV2 = new CheckoutCompleteOrderV2();
          try {
            checkoutCompleteOrderV2.init(response.data.htmlOfAutosubmitForm);
          } catch (e) {
            errorResponse(e.message);
          }
        } else {
          errorResponse(response.meta.feedback.message.basePropertyValue);
        }
      };
    } else {
      endpointUrl = 'enrollmentCheck';
      successResponse = function(response) {
        populateResponseFields(response.data);
        transactionStatusCheck(response.data);
      };
    }

    const errorResponse = function(error) {
      enableOrderSubmitButton();
      console.log(error);
    };

    if ($('#Terms1').is(':checked')) {
      disableOrderSubmitButton();
      $.ajax({
        url: endpointUrl,
        type: 'POST',
        data: $('#placeOrderForm1').serialize(),
        success: successResponse,
        error: errorResponse,
      });
    } else {
      $('#placeOrderForm1').submit();
    }
  });

  // When closing the modal, re-enable the 'Place your order' button
  $('#closePayerAuthModal').click(function(evt) {
    evt.preventDefault();
    enableOrderSubmitButton();
  });
});
